import { zodValidator } from '@tanstack/zod-adapter';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { CompanySecurityPage } from '../features/manage/company-settings-pages';
const SearchSchema = z.object({
  page: z.number().int().positive().catch(1),
  pageSize: z.union([z.literal(10), z.literal(25), z.literal(50), z.literal(100)]).catch(25),
});
export const Route = createFileRoute('/manage/$companySlug/settings/security')({
  component: RouteComponent,
  validateSearch: zodValidator(SearchSchema),
});
function RouteComponent() {
  const { companySlug } = Route.useParams();
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <CompanySecurityPage
      companySlug={companySlug}
      onPageChange={(page) => void navigate({ search: (previous) => ({ ...previous, page }) })}
      {...search}
    />
  );
}
